import "./instrument";
import ReactDOM from "react-dom/client";
import App from "./app/layout/App";
import reportWebVitals from "./reportWebVitals";
import { store, StoreContext } from "./app/stores/store";
import "react-toastify/dist/ReactToastify.min.css";
import { QueryClientProvider } from "@/app/providers/QueryClientProvider";
import VersionCheck from "@/features/version/VersionCheck";
import { IntercomProvider } from "react-use-intercom";
import { Intercom } from "@/app/lib/analytics/Intercom";
import "react-datepicker/dist/react-datepicker.css";

// Create a history object for backwards compatibility
export const history = {
  push: (path: string | { pathname: string; state?: any }, state?: any) => {
    // Handle both string paths and object parameters
    const pathname = typeof path === "string" ? path : path.pathname;
    const pathState = typeof path === "string" ? state : path.state;

    // Use window.history.pushState for programmatic navigation
    window.history.pushState(pathState || {}, "", pathname);
    // Dispatch a popstate event to trigger React Router's internal navigation
    window.dispatchEvent(new PopStateEvent("popstate", { state: pathState }));
  },
  replace: (path: string | { pathname: string; state?: any }, state?: any) => {
    // Handle both string paths and object parameters
    const pathname = typeof path === "string" ? path : path.pathname;
    const pathState = typeof path === "string" ? state : path.state;

    window.history.replaceState(pathState || {}, "", pathname);
    window.dispatchEvent(new PopStateEvent("popstate", { state: pathState }));
  },
  go: (n: number) => {
    window.history.go(n);
  },
  goBack: () => {
    window.history.back();
  },
  goForward: () => {
    window.history.forward();
  },
  listen: (callback: (location: any) => void) => {
    const handlePopState = () => {
      callback({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: window.history.state,
      });
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  },
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <QueryClientProvider>
    <StoreContext.Provider value={store}>
      <IntercomProvider
        appId={import.meta.env.VITE_INTERCOM_APP_ID}
        initializeDelay={1000}
        autoBoot
        autoBootProps={{
          hideDefaultLauncher: true,
        }}
      >
        <Intercom />
        <App />
      </IntercomProvider>
    </StoreContext.Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
